// extracted by mini-css-extract-plugin
export var container = "_6y-0";
export var error = "_6y-9";
export var label = "_6y-5";
export var light = "_6y-6";
export var md = "_6y-3";
export var sm = "_6y-2";
export var thin = "_6y-8";
export var thinBold = "_6y-7";
export var vertical = "_6y-4";
export var xs = "_6y-1";